import React from 'react';
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import classNames from 'classnames';
//material components
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

const styles = theme => ({
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0px 8px',
    marginTop: -8,
  },
  drawerPaper: {
    height: '100vh',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: theme.spacing.unit * 30,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
});

function AdminSideBar(props) {
  const { classes } = props;
  const navigate = route => () => props.history.push(route);
  return (
    <Drawer
      variant="permanent"
      classes={{paper: classNames(classes.drawerPaper, !props.open && classes.drawerPaperClose)}}
      open={props.open}
    >
      <List>
        <ListItem className={classes.toolbarIcon}>
          <IconButton onClick={props.toggle}>
            <ChevronLeftIcon />
          </IconButton>
        </ListItem>
        <Divider component="li" variant="fullWidth" light />
        {props.routes.map((route, idx) =>
        <ListItem key={idx} button selected={route.path === props.location.pathname} onClick={navigate(route.path)}>
          <ListItemIcon>
            {route.icon}
          </ListItemIcon>
          <ListItemText primary={route.name} />
        </ListItem>
        )}
      </List>
      <Divider />
    </Drawer>
  )
}

AdminSideBar.propTypes = {
  classes: PropTypes.object.isRequired,
  toggle: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  routes: PropTypes.array.isRequired,
};

export default withRouter(withStyles(styles)(AdminSideBar));
